import React from 'react';

import { MDText } from 'i18n-react';

import LocalTexts from '../../../../HomepageTexts.json';

import styles from './HeroContent.scss';

const LocalT = new MDText(LocalTexts);
const t = (key: string, args?: Record<string, string | React.ReactNode>) =>
  `${LocalT.translate(key, args)}`;

export const TEXTS = {
  subTitle: LocalT.translate('hero.subTitle', {
    TnC: <sup className={styles.TnC}>*</sup>,
  }),
  title: t('hero.title'),
};

export const HeroContent = () => (
  <div className={styles.component}>
    <h1 className={styles.title}>
      {TEXTS.title}
    </h1>
    <div className={styles.heroSubTitleWrapper}>
      <p className={styles.description} data-cy="homepageHeroVRM">
        {TEXTS.subTitle}
      </p>
    </div>
  </div>
);
